import React from 'react';
import { CheckboxInputRecord } from 'types/dynamic-forms/records/CheckboxInputRecord';
import WizardCheckboxComponent from 'components/v2/epd-wizard-inputs/WizardCheckbox';
import { CheckBoxPanel } from 'styles/v2/Styles.styled';
import useProperty from '../hooks/useProperty';
import usePropertyPath from '../hooks/usePropertyPath';
import { useDocumentStore } from '../hooks/useDocumentStore';

const CheckboxInputRenderer: React.FC<CheckboxInputRecord> = ({
  propertyId,
  tooltip,
  label,
  hideWhenReadOnly,
  setValuesOnCheck,
}) => {
  const store = useDocumentStore();
  const propertyPath = usePropertyPath(propertyId);
  const { value, setValue, isVisible, isDisabled, errorMessage } = useProperty<boolean>(propertyPath);

  if (!isVisible) {
    return null;
  }

  // Action-style checkboxes (e.g. service-agreement acceptance) are hidden, not shown read-only,
  // while their fields-area is not editable in the current document state.
  if (hideWhenReadOnly && isDisabled) {
    return null;
  }

  const handleChange = (checked: boolean) => {
    setValue(checked);
    if (checked && setValuesOnCheck) {
      for (const target of setValuesOnCheck) {
        store.setValue([target.propertyId], target.value);
      }
    }
  };

  return (
    <CheckBoxPanel>
    <WizardCheckboxComponent
      inputId={propertyId}
      label={label}
      tooltip={tooltip}
      name={propertyId}
      value={value ?? false}
      onChanged={(_: string, checked: boolean) => handleChange(checked)}
      disabled={isDisabled}
    />
    </CheckBoxPanel>
  );
};

export default CheckboxInputRenderer;
